import React from "react";

export const LogoIcon = ({ height = "45" }) => {
  return (
    <img
      src="/FinQ_Logo_C.png"
      alt="FinQ Logo"
      height={height}
      style={{ width: "auto" }}
    />
  );
};
